import React from 'react';
import classNames from 'classnames';
import { Box, ButtonBase, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { useTranslation } from 'services/localization/useTranslation';

interface Props {
	isRentNow: boolean;
	onChange: (isRentNow: boolean) => void;
}

const RentNowToggle = (props: Props) => {
	const { isRentNow, onChange } = props;
	const classes = useStyles();
	const { t } = useTranslation();

	return (
		<Box className={classes.rentNowToggle}>
			<ButtonBase
				className={classNames(classes.rentNowToggleButton, {
					[classes.rentNowToggleButtonActive]: isRentNow,
				})}
				onClick={() => onChange(true)}
				focusRipple
			>
				<Typography variant="button">{t('newRental.rentNow', 'Book now')}</Typography>
			</ButtonBase>
			<ButtonBase
				className={classNames(classes.rentNowToggleButton, {
					[classes.rentNowToggleButtonActive]: !isRentNow,
				})}
				onClick={() => onChange(false)}
				focusRipple
			>
				<Typography variant="button">{t('newRental.reserve', 'Reserve')}</Typography>
			</ButtonBase>
			<div
				className={classNames(classes.rentNowToggleBackground, {
					[classes.rentNowToggleBackgroundToggled]: !isRentNow,
				})}
			/>
		</Box>
	);
};

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		rentNowToggle: {
			width: '100%',
			display: 'flex',
			flexDirection: 'row',
			height: '56px',
			backgroundColor: 'rgba(255, 255, 255, 0.23)',
			borderRadius: 30,
			position: 'relative',
			overflow: 'hidden',
			zIndex: 2,
		},
		rentNowToggleButton: {
			flex: 1,
			height: '100%',
			position: 'relative',
			zIndex: 2,
			color: theme.palette.common.white,
			transition: 'color 0.3s ease',
		},
		rentNowToggleButtonActive: {
			color: theme.palette.text.primary,
		},
		rentNowToggleBackground: {
			position: 'absolute',
			left: 0,
			top: 0,
			height: '100%',
			width: '50%',
			background: theme.palette.background.paper,
			zIndex: 1,
			borderRadius: 30,
			transition: 'transform 0.3s ease-in-out',
		},
		rentNowToggleBackgroundToggled: {
			transform: 'translate3d(100%, 0, 0)',
		},
	}),
);

export default RentNowToggle;
